import CItemTitle from './c-item-title.vue';
import CButtonGroup from './c-button-group.vue';
import CCommonTab from './c-common-tab.vue';
import CCommonSearch from './c-common-search.vue';
import CCalendarStepper from './c-calendar-stepper.vue';

const baseComponentContent = require.context('@/components/base/', true, /\.vue$/);
let BASE_COMP_MAP = {};
// 遍历所有找到的 .vue 文件
baseComponentContent.keys().forEach(key => {
	const componentName = key.match(/\.\/([\w-]+)\.vue$/)[1];
	BASE_COMP_MAP[componentName] = baseComponentContent(key).default;
});

const globalComponents = {
	...BASE_COMP_MAP,

	CItemTitle,
	CButtonGroup,
	CCommonTab,
	CCommonSearch,
	CCalendarStepper
};

export default {
	install(Vue) {
		Object.keys(globalComponents).forEach(it => {
			Vue.component(it, globalComponents[it]);
		});
	}
};
